import { importProvidersFrom, ModuleWithProviders, NgModule } from '@angular/core';
import { CalGtmModule, ICalGtmConfig } from '@cal-analytics/gtm';
import { provideGtmAdapterService } from './services/gtm-adapter.provider';

@NgModule({
  providers: [],
  imports: []
})
export class GtmAdapterModule {
  public static forRoot(gtmConfig: ICalGtmConfig): ModuleWithProviders<GtmAdapterModule> {
    return {
      ngModule: GtmAdapterModule,
      providers: [importProvidersFrom(CalGtmModule.forRoot(gtmConfig)), provideGtmAdapterService()]
    };
  }
}
